export default "__VITE_ASSET__B2NNB6yS__"